
import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#0d47a1',
        secondary: '#ffffff',
        accent: '#0d47a1',
        error: '#FF5252',
        info: '#2196F3',
        success: '#0d47a1',
        warning: '#FFC107',
        background: '#f0f0f0',
        disabled: '#555555',
        subtitle: '#555555',
        background2: '#ffffff',
      },
    },
  },
});
